export const imageFileExtension = ".jpg, .jpeg, .png";
export const documentFileExtension = ".pdf";
export const iconFileExtension = ".png";
